import React from "react";
import {
	FaFacebookF,
	FaTwitter,
	FaLinkedinIn,
	FaInstagram,
} from "react-icons/fa";

const Footer = () => {
	return (
		<footer className="bg-gray-900 text-gray-300 pt-10 pb-5">
			<div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-8">
				{/* Company Info */}
				<div>
					<h2 className="text-2xl font-bold text-white mb-3">
						Diamond Heirs Limited
					</h2>
					<p className="text-sm leading-relaxed">
						A trusted IT company providing ICT Consulting, IT Infrastructure
						Installations, Power Installations, Civil Works, and innovative
						software solutions.
					</p>
				</div>

				{/* Quick Links */}
				<div>
					<h3 className="text-lg font-semibold text-white mb-3">Quick Links</h3>
					<ul className="space-y-2 text-sm">
						<li>
							<a href="/" className="hover:text-white">
								Home
							</a>
						</li>
						<li>
							<a href="/about" className="hover:text-white">
								About Us
							</a>
						</li>
						<li>
							<a href="/services" className="hover:text-white">
								Services
							</a>
						</li>
						<li>
							<a href="/contact" className="hover:text-white">
								Contact
							</a>
						</li>
					</ul>
				</div>

				{/* Contact Info */}
				<div>
					<h3 className="text-lg font-semibold text-white mb-3">Contact</h3>
					<ul className="space-y-2 text-sm">
						<li>📍 4 Tamale Street Wuze Zone 3 Abuja, FCT, Nigeria</li>
						<li>📞 +234 808 183 0114</li>
						<li>📧 info@diamond-heirs.ng</li>
					</ul>
				</div>

				{/* Social Media */}
				<div>
					<h3 className="text-lg font-semibold text-white mb-3">Follow Us</h3>
					<div className="flex space-x-4">
						<a href="#" className="text-gray-300 hover:text-white text-xl">
							<FaFacebookF />
						</a>
						<a href="#" className="text-gray-300 hover:text-white text-xl">
							<FaTwitter />
						</a>
						<a href="#" className="text-gray-300 hover:text-white text-xl">
							<FaLinkedinIn />
						</a>
						<a href="#" className="text-gray-300 hover:text-white text-xl">
							<FaInstagram />
						</a>
					</div>
				</div>
			</div>

			<div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-500">
				&copy; {new Date().getFullYear()} Diamond Heirs Limited. All Rights
				Reserved.
			</div>
		</footer>
	);
};

export default Footer;
